import { Col, Input, Radio, Row, Button, DatePicker,notification } from "antd";
import React, { useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import SelectAllType from "../../../../../components/SelectAllType";
import SelectOption from "../../../../../components/SelectOption";
import { actionEthics } from "../../../../../redux/slices/ethics";
import moment from "moment";
import * as XLSX from "xlsx";
import { axios } from "../../../../../utils/useAxios";

const display_type = {
  distributor: [
    { value: "", text: "ทั้งหมด" },
    { value: "waiting", text: "รอตรวจสอบ" },
  ],
  member: [
    { value: "", text: "ทั้งหมด" },
    { value: "waiting", text: "รอตรวจสอบ" },
    { value: "sponsor", text: "ไม่มีผู้แนะนำ" },
  ],
};

const filter_income = {
  income: [
    { value: "", text: "ทั้งหมด" },
    { value: "have_income", text: "มีรายได้" },
    { value: "no_income", text: "ไม่มีรายได้" },
  ],
};

export default function SearchPanel() {
  const dispatch = useDispatch();
  const search = useSelector((state) => state.ethics.search, shallowEqual);
  const list_data = useSelector((state) => state.ethics.list, shallowEqual);
  const [statusIncome, setStatusIncome] = useState("ปกติ");
  const { CLEAR_LIST, SET_MEMBER_TYPE, SET_SEARCH } = actionEthics;
  const [query, setQuery] = useState("");
  const [dateFrom, setDateForm] = useState("");
  const [dateTo, setDateTo] = useState("");

  const handleExportClick = async () => {
    if (!list_data || list_data?.data?.length === 0) {
      notification.warning({
        message: "แจ้งเตือน",
        description: "ไม่มีข้อมูลให้ export",
        placement: "topRight",
      });
      return;
    }
    
    let rowsSrc = [];
     
    try {
      const  response  = await axios.get(`/pos/ethics/export-excel`, {
        params: {
          limit: search.limit,
          offset: (search.page - 1) * search.limit,
          status: search.status,
          display_type: search.display_type,
          query: search.query,
          date_from: search.date_from
            ? moment(search.date_from).format("YYYY-MM-DD")
            : "",
          date_to: search.date_to
            ? moment(search.date_to).format("YYYY-MM-DD")
            : "",
          income_type: search.income_type || "",
        },
      });
    rowsSrc = response.data.data
    } catch (error) {
      console.log(error);
    }
    const headers = [
      "รหัสสมาชิก",
      "ชื่อสมาชิก",
      ...(search.member_type === "member" ? ["เบอร์โทรสมาชิก"] : ""),
      "รหัสผู้แนะนำ",
      "ชื่อผู้แนะนำ",
      "สถานะ",
      "เวลาที่สมัคร",
      ...(search.member_type === "distributor" ? ["การมีรายได้"] : ""),
      "เอกสารรอตรวจ",
    ];


const headFilterIncomeRow = [
  `นักธุรกิจ - ${
    (display_type[search?.member_type] || []).find(
      (f) => f.value === (search?.display_type || "")
    )?.text || "-"
  } , สถานะ : ${statusIncome}`,
  "", 
  `การมีรายได้ : ${
    filter_income.income.find((f) => f?.value === search?.income_type)?.text || "-"
  } , เวลาที่สมัคร : ${
    dateFrom && dateTo
      ? `${moment(dateFrom).format("DD/MM/YYYY")} - ${moment(dateTo).format("DD/MM/YYYY")}`
      : "-"
  }`,
  "", 
  `คำค้นหา : ${query || "-"}`, 
  "", 
  "", 
  "", 
  "", 
];

    const rows = rowsSrc.map((r) => {
      let docs = [];

      const files = r?.file || [];

      const missingDocumentType2 = files.some((f) => f.document_type === "2");
      if (!missingDocumentType2) {
        docs.push("• ขาดสำเนาบัตรประชาชน");
      }

      const missingDocumentType3 = files.some((f) => f.document_type === "3");
      if (!missingDocumentType3) {
        docs.push("• ขาดสำเนาสมุดบัญชี");
      }

      return [
        r?.partner_code ?? "",
        `${r?.first_name_th ?? ""} ${r?.sur_name_th ?? ""}`.trim(),
        ...(search.member_type === "member" ? [r?.mobile ?? ""] : ""),
        r?.sponsor_code ?? "",
        r?.sponsor_name ?? "",
        r?.status_name ?? "",
        r?.register_date ? moment(r.register_date).format("DD/MM/YYYY") : "",
        r?.is_income ? "มีรายได้" : "",
        docs.join("\n"),
      ];
    });

    const ws_data = [
      [`วันที่ดึงข้อมูล ${moment().format("DD/MM/YYYY")}`],
      headFilterIncomeRow,
      headers,
      ...rows,
    ];

    const ws = XLSX.utils.aoa_to_sheet(ws_data);

    ws["!merges"] = [
  { s: { r: 0, c: 0 }, e: { r: 0, c: 8 } }, 
  { s: { r: 1, c: 0 }, e: { r: 1, c: 1 } }, 
  { s: { r: 1, c: 2 }, e: { r: 1, c: 3 } }, 
  { s: { r: 1, c: 4 }, e: { r: 1, c: 6 } }, 
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "รายชื่อสมาชิก");
    XLSX.writeFile(wb, "รายชื่อสมาชิก.xlsx");
  };

  return (
    <>
      <Row className="mb-2" gutter={16}>
        <Col>
          <Radio.Group
            value={search.member_type}
            onChange={(e) => {
              dispatch(CLEAR_LIST());
              dispatch(SET_MEMBER_TYPE(e.target.value));
              setQuery("");
            }}
          >
            <Radio value="distributor">นักธุรกิจ</Radio>
            <Radio value="member">VIP Member</Radio>
          </Radio.Group>
        </Col>
      </Row>
      <Row className="mb-1" gutter={16}>
        <Col md={12}></Col>
        {search.member_type === "distributor" && (
          <Col md={4}>
            <label>การมีรายได้</label>
          </Col>
        )}
        <Col md={4}>
          <label>เวลาที่สมัคร</label>
        </Col>
      </Row>
      <Row className="mb-3" gutter={16}>
        <Col md={6}>
          <SelectOption
            className="w-100"
            data={display_type[search.member_type]}
            value={search.display_type}
            onChange={(e) =>
              dispatch(
                SET_SEARCH({
                  display_type: e,
                  page: 1,
                })
              )
            }
          />
        </Col>
        <Col md={6}>
          <SelectAllType
            className="w-100"
            process_type={
              search.member_type === "distributor"
                ? "partner_status_local"
                : "member_status_local"
            }
            value={search.status}
            withAll
            allText="ทั้งหมด"
            onChange={(value, option) => {
              const label = option?.props?.children || "";
              setStatusIncome(label);
              dispatch(SET_SEARCH({ status: value, page: 1 }));
            }}
          />
        </Col>
        {search.member_type === "distributor" && (
          <>
            <Col md={4}>
              <SelectOption
                className="w-100"
                data={filter_income?.income}
                value={search?.income_type}
                onChange={(val) =>
                  dispatch(
                    SET_SEARCH({
                      income_type: val ?? "",
                      page: 1,
                    })
                  )
                }
                placeholder="การมีรายได้"
              />
            </Col>
          </>
        )}
        <Col md={4}>
          <DatePicker.RangePicker
            className="w-100"
            placeholder={["วันที่เริ่มต้น", "วันที่สิ้นสุด"]}
            value={[search.date_from, search.date_to]}
            format="DD/MM/YYYY"
            onChange={(e) => {
              const [start, end] = e || [];
              setDateForm(start || "");
              setDateTo(end || "");
              dispatch(
                SET_SEARCH({
                  date_from: start || "",
                  date_to: end || "",
                  page: 1,
                })
              );
            }}
          />
        </Col>
        <Col md={4}>
          <Button
            type="primary"
            className="primary-500"
            onClick={handleExportClick}
          >
            Export to Excel
          </Button>
        </Col>
      </Row>
      <Row className="mb-3" gutter={16}>
        <Col md={12}>
          <Input.Search
            placeholder="รหัสสมาชิก, เลขบัตรประชาชน, ชื่อสมาชิก, เบอร์โทร, E-mail"
            value={query}
            onChange={(e) => setQuery(e.target.value || "")}
            onSearch={(e) =>
              dispatch(
                SET_SEARCH({
                  query: e || "",
                  page: 1,
                })
              )
            }
            allowClear
          />
        </Col>
      </Row>
    </>
  );
}
